import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../Firebase/firebase-config";
import { ref, get } from "firebase/database";

export default function PartnerProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        navigate("/partner-login", { replace: true });
        setLoading(false);
        return;
      }

      // Verify partner
      const snapshot = await get(ref(db, "profileDashboard"));
      let isPartner = false;
      snapshot.forEach((mainSnap) => {
        const partners = mainSnap.child("partners").val();
        if (partners && partners[user.uid]) {
          isPartner = true;
        }
      });

      if (!isPartner) {
        alert("Access denied. Partners only.");
        auth.signOut();
        navigate("/partner-login", { replace: true });
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return <div></div>;
  }

  return children;
}